/** Time reserved for group collection, payment, and normal scheduled dispatch. */
export const groupScheduleLeadMinutes = ({ mode, cutoffMinutes, windows = {}, scheduling = {} }) =>
  Number(cutoffMinutes || 30) + Number(windows.topUpMinutes ?? 10) + Number(windows.hostPayMinutes ?? 10) +
  (mode === "HOST_PAYS_ALL" ? 0 : Number(windows.memberPayMinutes ?? 10) + 2 * Number(windows.paymentGraceMinutes ?? 3)) +
  Number(scheduling.orderLeadMinutes ?? 45) + Number(scheduling.releaseBufferMinutes ?? 1);

export const earliestGroupWindow = (options) =>
  new Date(Date.now() + groupScheduleLeadMinutes(options) * 60000).toISOString();

export const filterGroupDeliveryDays = (days = [], earliestWindowStart = null) => {
  if (!earliestWindowStart) return days;
  const earliest = new Date(earliestWindowStart).getTime();
  return days.map((day) => ({ ...day, windows: day.windows.filter((window) => new Date(window.start).getTime() >= earliest) }));
};

export const groupDeliveryLabel = (basket) => basket?.deliverySchedule === "Scheduled"
  ? `Delivery: ${basket.scheduledDelivery?.label || "Scheduled window"}`
  : "Express delivery";
